import type { ErrorInfo } from 'react';

import { Boundary } from '@/domains/shared/components/Boundary';
import { ErrorScreen } from '@/domains/shared/components/ErrorScreen';
import { Loading } from '@/domains/shared/components/Loading/Loading';

type LoadingBoundaryProps = {
  fallback?: React.ReactNode;
  onError?: (error: Error, info: ErrorInfo) => void;
  children: React.ReactNode;
};

export const LoadingBoundary = ({
  fallback,
  onError,
  children,
}: LoadingBoundaryProps) => (
  <Boundary
    loadingFallback={fallback ?? <Loading variant="page" />}
    errorFallback={({ error }) => <ErrorScreen error={error} />}
    onError={onError}
  >
    {children}
  </Boundary>
);
